/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { campaignAction } from "@redux/modules";
import moment from "moment";
import { NavLink } from "react-router-dom";

// Header - Footer
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";

// Styles
import "./styles.scss";

/**
 * Kampanyalarımız — aktif kampanya döneminin kampanyalarını /magazine ekranıyla
 * aynı tasarımda listeler (kategori kenar çubuğu yoktur; içerik tam genişliktir).
 * Bir kampanyaya tıklanınca detay sayfası (/campaigns/:id) açılır.
 *
 * İçerik yalnızca Satış Temsilcisi (USER) rolüne döner (backend kısıtı). Diğer
 * roller bu menüye yetkilendirilse bile şimdilik boş görür.
 */
const Campaigns = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  const campaignList = useSelector((store) => store.campaign.campaignList);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await dispatch(campaignAction.getUserCampaignList());
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    return () => {};
  }, [dispatch]);

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const formatRange = (item) => {
    if (!item) return "";
    const begin = item.dateBegin
      ? moment(item.dateBegin).format("DD.MM.YYYY")
      : "";
    const end = item.dateEnd ? moment(item.dateEnd).format("DD.MM.YYYY") : "";
    if (begin && end) return `${begin} - ${end}`;
    return begin || end;
  };

  const list = Array.isArray(campaignList) ? campaignList : [];

  return (
    <div className="page-container">
      <Header />

      <main>
        <section className="bg-blue py-5 mb-sm-5 mb-3 d-lg-block d-none">
          <div className="container">
            <div className="d-lg-flex d-none text-white small mb-4 opacity-50">
              <NavLink
                to="/home"
                className="text-white text-decoration-none me-3"
              >
                Anasayfa
              </NavLink>
              <span className="me-3">»</span>
              <span>Kampanyalarımız</span>
            </div>
          </div>
        </section>

        <section className="mb-sm-10 mb-5 mt-lg-0 mt-sm-5 mt-3">
          <div className="container">
            <div className="row gy-0">
              <div className="col-12">
                {isLoading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                  </div>
                ) : list.length > 0 ? (
                  <div className="mb-sm-n4 mb-n2">
                    {list.map((item) => (
                      <NavLink
                        to={`/campaigns/${item.id}`}
                        className="campaign-item d-block overflow-hidden position-relative rounded-3 shadow text-decoration-none text-reset mb-sm-4 mb-2"
                        key={item.id}
                      >
                        <div className="row g-0 align-items-stretch">
                          <div className="col-md-6">
                            {item.contentList &&
                            item.contentList.length > 0 ? (
                              <div className="campaign-item__media">
                                <img src={item.contentList[0]} alt={item.name} />
                              </div>
                            ) : (
                              <div className="campaign-item__media-empty" />
                            )}
                          </div>
                          <div className="col-md-6 px-sm-5 px-4 py-4 align-self-center">
                            {formatRange(item) && (
                              <span className="d-block text-blue small mb-1">
                                {formatRange(item)}
                              </span>
                            )}
                            <h5 className="mb-3 lh-base">{item.name}</h5>
                            <p className="fw-light small mb-0 d-xl-block d-none">
                              {decodeHtml(
                                (item.content || "").replace(
                                  /<\/?[^>]+(>|$)/g,
                                  ""
                                )
                              ).slice(0, 100)}
                              ...
                            </p>
                            {item.campaignPeriodName && (
                              <span className="d-block text-blue small mt-4">
                                #{item.campaignPeriodName}
                              </span>
                            )}
                          </div>
                        </div>
                      </NavLink>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <p>Görüntülenecek kampanya bulunamadı.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Campaigns;
